"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminPath = exports.adminV1ApiEndpoint = exports.V1ApiEndpoint = void 0;
var V1ApiEndpoint = '/api/v1';
exports.V1ApiEndpoint = V1ApiEndpoint;
var adminV1ApiEndpoint = '/api/v1/rivendell';
exports.adminV1ApiEndpoint = adminV1ApiEndpoint;
var adminPath = '/rivendell';
exports.adminPath = adminPath;